<template>
  <span class="path-display">
    <template v-for="(p, index) in parts">
      <a href="#" class="path-item" :key="index">
        <img src="../assets/plain-folder.png" width="16" height="16" alt="folder">
        {{ p }}
      </a>
    </template>
  </span>
</template>

<script>
// import {computed} from 'vue'

// const props = defineProps(['path'])
// const $emit = defineEmits(['gotoPath'])

// const gotoPath = (index) => {
//   let path
//   if (index == 0) {
//     path = '/'
//   }
//   else {
//     path = parts.value.slice(0, index + 1)
//     path = path.join('/')
//   }
//
//   $emit('gotoPath', path)
// }

export default {
  name: 'PathDisplay',
  props: ['path'],
  computed: {
    parts() {
      if (this.$props.path === undefined || this.$props.path instanceof Promise ) {
        return []
      }
      else if (this.$props.path == 'Root') {
        return ['Home']
      }
      else if (Array.isArray(this.$props.path)) {
        return this.$props.path
      }


      let parts = this.$props.path.split('.')
      if (parts[0] == 'Root') {
        parts[0] = 'Home'
      }

      for (let part of parts) {
        part = part.replace(/ /g, '_')
      }
      return parts
    }
  }
}

</script>

<style lang=scss>
.path-display {
  display: inline-flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  /* background: white; */
  min-width: 320px;

  .path-item {
    position: relative;
    color: #333;
    flex: 0 1 auto;
    margin: 0 5px 0 0;
    padding: 2px 4px;
    text-decoration: none;

    img {
      display: inline-block;
      margin-bottom: -3px;
    }
    
    &::after {
      position: absolute;
      width: 12px;
      right: -6px;
      top:2px;
      bottom:0;
      left: auto;
      content: "";
      display: block;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><polyline points="8,0 14,8 8,16" fill="none" stroke-width="2" stroke="%23aaa" /></svg>');
      background-repeat: no-repeat;
      background-color: transparent;
      background-position: 100% 50%;
    }

    &:last-child::after {
      display: none;
    }
  }
}
</style>
